const autoNgTemplateLoaderTemplate1 = require('./add-license.view.html');

import controller from './add-license.view.controller.js';

export const addLicenseView = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
};
